import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { CompareDetail } from '@src/pages/Compare';

export const Route = createLazyFileRoute('/compare/crowdstrike')({
  component: CrowdStrikeComparePage,
});

function CrowdStrikeComparePage() {
  return (
    <DefaultLayout>
      <CompareDetail competitorId="crowdstrike" />
    </DefaultLayout>
  );
}
